var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowRigthSmall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_360",
    width: 7.197,
    height: 12,
    "data-name": 360,
    viewBox: "0 0 7.197 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M1.2 12l6-6-6-6L0 1.205 4.8 6 0 10.8z",
    "data-name": "Path 13"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRigthSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow_rigth_small.0d74f4e1.svg";
export { ForwardRef as ReactComponent };